'use client';

import { type Dispatch, useReducer } from 'react';

import { type ImageGenerationSubmitState, type ImageGenerationSubmitAction } from '../types';

export const IMAGE_GENERATION_SUBMIT_DEFAULTS: ImageGenerationSubmitState = {
    status: 'idle',
    pendingTaskId: null,
    imageUrl: null,
    aiContentId: '',
    lastAiContentId: '',
    aiContentType: null,
    aiModelName: null,
    restoredFromHistory: false,
    failureReason: null,
};

export function imageGenerationSubmitReducer(
    state: ImageGenerationSubmitState,
    action: ImageGenerationSubmitAction,
): ImageGenerationSubmitState {
    switch (action.type) {
        case 'GENERATION_IN_PROGRESS':
            if (state.status === 'inProgress' && !action.pendingTaskId) return state;
            return {
                ...state,
                status: 'inProgress',
                imageUrl: null,
                restoredFromHistory: false,
                pendingTaskId: action.pendingTaskId ?? null,
                aiContentId: action.aiContentId ?? state.aiContentId,
                lastAiContentId: action.lastAiContentId ?? state.lastAiContentId,
                aiContentType: action.aiContentType ?? state.aiContentType,
                aiModelName: action.aiModelName ?? state.aiModelName,
                failureReason: null,
            };
        case 'GENERATION_SUCCESS':
            return {
                ...state,
                status: 'success',
                imageUrl: action.imageUrl,
                restoredFromHistory: false,
                pendingTaskId: null,
                aiContentId: action.aiContentId,
                lastAiContentId: action.lastAiContentId,
                aiContentType: action.aiContentType ?? state.aiContentType,
                aiModelName: action.aiModelName ?? state.aiModelName,
                failureReason: null,
            };
        case 'GENERATION_ERROR':
            return {
                ...state,
                status: 'error',
                imageUrl: null,
                restoredFromHistory: false,
                pendingTaskId: null,
                aiContentType: null,
                aiModelName: null,
                failureReason: action.failureReason ?? null,
            };
        case 'RESET':
            return IMAGE_GENERATION_SUBMIT_DEFAULTS;
    }
}

export function useImageGenerationSubmit(
    initialState: ImageGenerationSubmitState = IMAGE_GENERATION_SUBMIT_DEFAULTS,
): [ImageGenerationSubmitState, Dispatch<ImageGenerationSubmitAction>] {
    return useReducer(imageGenerationSubmitReducer, initialState);
}
